import React, { Component, useState, useMemo, useEffect } from "react";
import Select from "react-select";
import "../../styles/select.css";
import { UncontrolledTooltip, Badge } from "reactstrap";
import { generateOtherValues, getObjectsValue, goToName } from "../oro-module/commonFunctions";
import { fetchData } from "../common/networkRequests";





const AutocompleteCustom = (props) => {

  let [loading, setloading] = useState(false);
  let [optionvalues, setoptionvalues] = useState([]);

  let { height } = props.component.style;

  const customStyles = {
    control: base => ({
      ...base,
      height: height ? height : 31,
      minHeight: 31,
      border: "1px solid #AAA"
    })
  };

  const handleSelectChange = (value) => {
    let x = props.parentState.errorMessages;
    let { name, displayData } = props.component;
    x[name] = "";
    let { LocalVars, currentPage } = props.parentState;
    // console.log({ C: props.component, value })

    props.liftGlobalState({ name: "errorMessages" }, x);
    props.liftState(props.component, value ? value.value : null);

    props.liftState({ name: name.replace('_code', '_display') }, value ? value.label : null);
    props.liftState({ name: name.replace('_code', '_uid') }, value ? value.uid : null);

    if (displayData) {
      for (var key in displayData) {
        props.liftState({ name: displayData[key] }, value[displayData[key]] ? value[displayData[key]] : null);

      }
    }

  }


  const handleOnInputChange = (currentVal) => {

    const setvals = (response) => {
      setloading(false);
      let options = [];

      let { results, exceptions, vendorErrors, error, success } = response;
      if (!error && results) {
        results.map(r => options.push({ value: r.value, label: r.label, uid: r.uid }));
      }
      setoptionvalues(options)
    }
    let { name, displayData, defaultValue, options, controlType, is_ajax } = props.component;

    if (currentVal.length > 3 && is_ajax) {
      let { LocalVars, currentPage } = props.parentState;
      let saveThis = { dataType: controlType + "_control", value: currentVal, reverse: false, currentPage, fieldName: name };
      setloading(true);
      let response = fetchData({ url: 'cbsurl', postData: saveThis, method: "post", current: { props }, cbf: setvals });
    }
    // this.setState({ currentVal });
  }

  const generateOtherValues = (sendData) => {
    let { pageData, openmodals } = props.parentState;

    let returnVal = {}
    if (sendData && sendData.length != 0) {
      sendData.map(otherfield => {
        if (otherfield.varname) {
          if (otherfield.fixed) {
            returnVal[otherfield.varname] = otherfield.fixed;
          } else {
            returnVal[otherfield.varname] = getObjectsValue(pageData, otherfield.value);
          }
        } else {
          returnVal[otherfield] = getObjectsValue(pageData, otherfield);
        }
      })
    }
    return returnVal
  }



  const fetchControlData = async () => {
    let { fileFolder, formState, modalname, pageData, isReadOnly, currentPage } = props.parentState;
    let { conditionalRender } = props;

    let { name, displayData, defaultValue, options, controlType, is_ajax } = props.component;
    if (
      pageData &&
      ((!modalname && !pageData[name]) || (modalname && (!pageData[modalname] || !pageData[modalname][name]))) &&
      defaultValue
    ) {
      props.liftState(props.component, props.component.default);
    }

    let isReadOnly1 = false;
    if (formState != 'edit' || isReadOnly == true || (formState == 'edit' && isReadOnly == 'edit') || conditionalRender == 'readonly') {
      isReadOnly1 = true;
    }

    if (!is_ajax && controlType && !isReadOnly1) {
      options = [];
      setloading(true);

      let { dataType, sendData, func } = props.component.sendToServer;

      let moredata = generateOtherValues(sendData);

      let saveThis = { dataType: controlType + "_control", value: "", reverse: false, currentPage, fieldName: name, dependantOnValues: moredata };

      if (name == 'term_deposit.scheme_code') {
        console.log({ moredata, saveThis, pageData });
      }

      let response = await fetchData({ url: 'cbsurl', postData: saveThis, method: "post", current: { props } });
      setloading(false);
      let { results, exceptions, vendorErrors, error, success } = response;



      if (!error && results) {
        results.map(r => {
          let optionsdata = { value: r.value, label: r.label, uid: r.uid };
          // SET displayData 
          if (displayData) { // village_display:village_display, taluka_display:taluka_display,
            for (var key in displayData) {
              optionsdata[displayData[key]] = r[key];
            }
          }
          options.push(optionsdata)
        });
      }
      setoptionvalues(options)
      if (options.length == 1) {
        setTimeout(() => {
          handleSelectChange(options[0]);
        }
          , 20)
      }
    }
  }


  const {
    name,
    label,
    placeHolder,
    description,
    elementProps,
    isReadOnly,
    subType,
    next_field,
    disableSearch
  } = props.component;
  let { conditionalRender } = props;


  let { currentPage, fileFolder, formState, openmodals, pageData, errorMessages } = props.parentState;
  let boxvalue;
  let modalname = openmodals[openmodals.length - 1];

  let fld_display = pageData[name.replace('_code', '_display')];
  let fld_uid = pageData[name.replace('_code', '_uid')];

  if (pageData[name]) {
    let x;
    if (!fld_display) {
      optionvalues.map(ov => ov.value == pageData[name] ? fld_display = ov.label : x = 0)
    }
    if (!fld_uid) {
      optionvalues.map(ov => ov.value == pageData[name] ? fld_uid = ov.uid : x = 0)
    }
  }

  boxvalue = { value: pageData[name], label: fld_display, uid: fld_uid };


  let isReadOnly1 = false;
  if (formState != 'edit' || isReadOnly == true || (formState == 'edit' && isReadOnly == 'edit') || conditionalRender == 'readonly') {
    isReadOnly1 = true;
  }

  let currentError
  if (errorMessages) {
    if (modalname && errorMessages[modalname] && errorMessages[modalname][name]) {
      currentError = errorMessages[modalname][name];
    } else if (!modalname && errorMessages[name]) {
      currentError = errorMessages[name];
    }
  }



  let { dataType, sendData, func } = props.component.sendToServer;
  let dependson = sendData ? sendData[0]['value'] : false;
  let dov = false;

  if (dependson) {
    dov = pageData[dependson];
  }



  useEffect(() => {
    let wait = 1;
    if (props.component.sendToServer) {
      wait = 300;
    }
    if (!isReadOnly) {
      setTimeout(fetchControlData, wait);
    }
  }, []);

  useMemo(() => {
    let wait = 1;
    if (props.component.sendToServer) {
      wait = 300;
    }
    if (!isReadOnly) {
      setTimeout(fetchControlData, wait);
    }
  }, [dov]);



  return (
    <div className={`form-group ${props.component.widths.parent}`}>
      {label && label != "" && (
        <span>
          <label
            className={`col-form-label col-form-label-sm nopadding ${height ? "mobile_label" : ""}`}
          >
            {label}
            {/* {" " + this.state.errorMessage} */}
          </label>
        </span>
      )}
      {conditionalRender && conditionalRender != 'blank' &&
        <div className="input-group input-group-sm ">
          {props.component.prepend && props.component.prepend != "" && (
            <div className="input-group-prepend">
              <div className="input-group-text">
                {props.component.prepend}
              </div>
            </div>
          )}
          <div

            // className={`col-12 form-control form-control-sm primary ${this.props.parentState.errorMessages != undefined && this.props.parentState.errorMessages[name] ? "validationErrorBox" : ""}`}
            className="col-12 autocomplete_select"
            style={{ border: 0, padding: 0 }}
          >
            <Select
              // id={tooltipID2}
              name={name}
              className={`autocomplete_container ${height ? "autocomplete_mobile" : ""} ${currentError ? "validationErrorBox" : ""}`}
              type={subType}
              placeholder="Select"
              closeOnSelect={!elementProps.stayOpen}
              isDisabled={loading || isReadOnly1}
              onChange={handleSelectChange}
              onInputChange={handleOnInputChange}
              options={optionvalues}
              removeSelected={elementProps.removeSelected}
              rtl={elementProps.rtl}
              isClearable={true}
              isSearchable={disableSearch ? false : true}
              value={boxvalue}
              styles={customStyles}
              maxMenuHeight={220}
              onKeyDown={(e) => goToName(e, next_field, name, { props })}
            />
          </div>
        </div>
      }
    </div>
  );

}

export default AutocompleteCustom;